import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Browser from './Browser';

const OrderBrowser = () => {
  const { path } = useRouteMatch();

  return (
    <div className="order-browser">
      <Switch>
        <Route path={path + '/folders/:folderId'} exact>
          <Browser />
        </Route>
        <Route path={path + '/'} exact>
          <Browser />
        </Route>
      </Switch>
    </div>
  );

};

export default OrderBrowser;
